






import Vue from 'vue'
export default Vue.extend({
  model: {
    prop: 'value'
  },
  props: {
    value: Boolean,
    colorize: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    iconString (): string { return this.value ? 'fa-check-circle' : 'fa-minus-circle' },
    color (): string | undefined {
      if (this.colorize) { return this.value ? '#86c255' : '#f55' }
      return undefined
    }
  }
})
